import React from 'react';
import Text from 'components/Text';
import useUniqueId from 'hooks/useUniqueId';
function SimpleListItem(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle;
  var titleId = useUniqueId();
  return /*#__PURE__*/React.createElement("article", {
    "aria-labelledby": titleId
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    as: "h4",
    size: "s",
    id: titleId
  }, title), subtitle && /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: "xs"
  }, subtitle));
}
export default SimpleListItem;